/**
 * ImageResults Component
 *
 * Display generated image results.
 */

import { memo } from 'react';
import { ImageResultDisplay } from '../../components/image';

import type { ImageResult } from '../../types';

interface ImageResultsProps {
  images: ImageResult[];
  processingTime?: number;
  onReset: () => void;
}

export const ImageResults = memo(function ImageResults({
  images,
  processingTime,
  onReset,
}: ImageResultsProps) {
  return (
    <div className="card p-6" data-testid="image-result-container">
      <ImageResultDisplay images={images} processingTime={processingTime ?? 0} onReset={onReset} />
    </div>
  );
});
